(function JuzoSearch() {

    $(document).ready(function () {

        $.each($('[name="search"]'), function (index, rawSearchInput) {
            var searchInput = $(rawSearchInput);
            searchInput.autocomplete({
                serviceUrl: searchInput.data('autocomplete-source'),
                paramName: 'term',
                dataType: 'json',
                triggerSelectOnValidInput: false,
                onSelect: function (suggestion) {
                    searchInput.parents('form').submit();
                },
                transformResult: function (response) {
                    return {
                        suggestions: $.map(response.completions, function (dataItem) {
                            return {value: dataItem, data: dataItem};
                        })
                    };
                }
            });

        });
    });

})();